import * as React from 'react';
import { PlanFormInfoComponent as NewPlanFormInfoComponent } from './PlanFormInfo.component';
import { usePlanContext } from '../../context/PlanContext';
import { PlanFormValues } from './PlanFormInfo.type';
import { useFormContext } from 'react-hook-form';

export function PlanFormInfoComponent(): JSX.Element {
  const {
    errors,
    plan,
    setUploadImage,
  } = usePlanContext();

  const form = useFormContext<PlanFormValues>();
  
  const handlePlanChange = (updatedPlanData: any) => {
    Object.entries(updatedPlanData).forEach(([key, value]) => {
      if (value !== undefined) {
        form.setValue(key, value);
      }
    });
  };

  return (
    <NewPlanFormInfoComponent 
      plan={plan as any}
      onPlanChange={handlePlanChange}
      onImageUpload={setUploadImage}
    />
  );
}